module.exports = __webpack_public_path__ + "img/3-4.b4e1491a.svg";